export enum Order {
  Asc = 'ASC',
  Desc = 'DESC',
}
